import { addBreadcrumb } from '@sentry/react';

import { addRumAction } from '@/lib/datadog-rum';
import { consumeStaleChunkReport } from '@/lib/stale-chunk-reload';

/**
 * Ships the previous boot's stale-chunk recovery, if there was one.
 *
 * Recovery reloads are invisible to both telemetry backends by construction:
 * `TabErrorBoundary` catches the failure, so it is never an unhandled error RUM
 * would collect, and the reload destroys the page before an in-page reporter
 * could flush. So the signal is picked up on the NEXT boot from the handoff
 * `reloadForStaleChunk` leaves behind.
 *
 * MUST run after `initSentry()` / `initDatadogRum()` — both drop calls made
 * before their init.
 *
 * Payload is a source + signature code and an age. The raw failure message
 * embeds the chunk URL and never travels.
 */
export function reportStaleChunkReload(): void {
  const report = consumeStaleChunkReport();
  if (!report) {
    return;
  }

  const context = {
    source: report.source,
    signature: report.signature,
    ageMs: Math.max(0, Date.now() - report.at),
  };

  addRumAction('stale_chunk_reload', context);
  addBreadcrumb({
    category: 'navigation',
    level: 'warning',
    message: 'stale_chunk_reload',
    data: context,
  });
}
